import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Feedback from './feedback-model'
import {
  CreateFeedbackAsync,
  DeleteFeedbackAsync,
  LoadFeedbacksAsync,
} from './feedback-thunk'
const initialState: feedbackSliceState = {
  feedback: [],
  selected_feedback: '',
  is_loading_feedback: false,
  is_creating_feedback: false,
  is_deleting_feedback: false,
}
export interface feedbackSliceState {
  feedback: Feedback[]
  selected_feedback?: string
  is_loading_feedback: boolean
  is_creating_feedback: boolean
  is_deleting_feedback: boolean
}
export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    setSelectedfeedback: (state, action) => {
      state.selected_feedback = action.payload
    },
    clearStatefeedback: (state) => {
      state.feedback = []
      state.is_loading_feedback = false
      state.is_creating_feedback = false
      state.is_deleting_feedback = false
    },
    mergefeedback: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_feedback = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.feedback = merge(state.feedback, payload) as any
        }
      }
    },

    add_feedback: (state, action) => {
      if (action.payload) {
        state.feedback = [...state.feedback, action.payload]
      }
    },
    set_feedback: (state, action) => {
      let { key, value, id } = action.payload
      state.feedback = state.feedback.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadFeedbacksAsync.pending, (state) => {
      state.is_loading_feedback = true
    })
    builder.addCase(LoadFeedbacksAsync.fulfilled, (state, action) => {
      state.is_loading_feedback = false
      if (action.payload) {
        state.feedback = action.payload
      }
    })
    builder.addCase(LoadFeedbacksAsync.rejected, (state) => {
      state.is_loading_feedback = false
    })
    builder.addCase(CreateFeedbackAsync.pending, (state) => {
      state.is_creating_feedback = true
    })
    builder.addCase(CreateFeedbackAsync.fulfilled, (state) => {
      state.is_creating_feedback = false
    })
    builder.addCase(CreateFeedbackAsync.rejected, (state) => {
      state.is_creating_feedback = false
    })
    builder.addCase(DeleteFeedbackAsync.pending, (state) => {
      state.is_deleting_feedback = true
    })
    builder.addCase(DeleteFeedbackAsync.fulfilled, (state, action) => {
      state.is_deleting_feedback = false
      if (state.feedback) {
        state.feedback = state.feedback.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteFeedbackAsync.rejected, (state) => {
      state.is_deleting_feedback = false
    })
  },
})

export const {
  clearStatefeedback,
  setSelectedfeedback,
  set_feedback,
  mergefeedback,
  add_feedback,
} = feedbackSlice.actions

export const get_feedback =
  (id?: string) =>
  (state: {
    feedback: {
      feedback: Feedback[]
    }
  }): Feedback | null => {
    let temp = state?.feedback?.feedback?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.feedback?.feedback[0] || null
  }
export const get_selected_feedback = (state: {
  feedback: feedbackSliceState
}): Feedback | null => {
  let id = state?.feedback?.selected_feedback
  let temp = state?.feedback?.feedback?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_feedback = (state: {
  feedback: {
    feedback: Feedback[]
  }
}): Feedback[] => {
  let temp = state?.feedback?.feedback
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_feedback_busy = (state: { feedback: feedbackSliceState }) => {
  return (
    state?.feedback.is_deleting_feedback ||
    state?.feedback.is_loading_feedback ||
    state?.feedback.is_creating_feedback
  )
}
export const is_deleting_feedback_busy = (state: {
  feedback: feedbackSliceState
}) => {
  return state?.feedback.is_deleting_feedback
}
export const is_loading_feedback_busy = (state: {
  feedback: feedbackSliceState
}) => {
  return state?.feedback.is_loading_feedback
}
export const is_creating_feedback_busy = (state: {
  feedback: feedbackSliceState
}) => {
  return state?.feedback.is_creating_feedback
}

export default feedbackSlice.reducer
